/* Review slider (social-proof section). Auto-advances slides every 10s;
   pauses on hover/focus, stops for prefers-reduced-motion, dots jump. */
(function () {
  var INTERVAL = 10000;

  function init(root) {
    var track = root.querySelector('[data-pc-reviews-track]');
    if (!track) return;
    var slides = track.children.length;
    if (slides < 2) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-pc-reviews-dot]'));
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var current = 0;
    var timer = null;

    function go(n) {
      current = ((n % slides) + slides) % slides;
      track.style.transform = 'translateX(-' + current * 100 + '%)';
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function start() {
      stop();
      if (reduceMotion.matches) return;
      timer = setInterval(function () { go(current + 1); }, INTERVAL);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { go(i); start(); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      document.hidden ? stop() : start();
    });

    start();
  }

  function boot() {
    document.querySelectorAll('[data-pc-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
